<h1 mat-dialog-title>
    {{title}}
  </h1>
  
  <div mat-dialog-content>
    <h4>Rechazado por:</h4>
    <p>{{json['rejected_by']['first_name'] + ' ' + json['rejected_by']['last_name']}}</p>
  </div>

  <div mat-dialog-content>
    <h4>Fecha:</h4>
    <p>{{json['rejected_date'] | date: 'dd-MM-YYYY'}}</p>
  </div>

  <div mat-dialog-content>
    <h4>Razón:</h4>
    <p>{{json['rejected_reason']}}</p>
  </div>
  
  <div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="onDismiss()">Cerrar</button>
    <!--<button mat-raised-button color="primary" (click)="onConfirm()">Aceptar</button>-->
  </div>
